<div class="dt-bootstrap"   [ngClass]= '{"instore-background":!this.isBuyNow , "buyNow": this.isBuyNow, "appModal": apiDomain}'>
<dt-dt-an-creditapplication-lib></dt-dt-an-creditapplication-lib>
</div>
